<template>
    <div 
        ref="root"
        tabindex="0" 
        class="neo-inputer"
        @keyup="keyPressHandler" 
        >
        
        <input
            type="text" 
            v-model="formattedValue" 
            ref="input" 
            readonly
            @click="opened=!opened"
            style="font-size: 14px"
        />
            

        <Teleport to="body">
            <div
                ref="popup"
                class="neo-selector" 
                v-show="opened"
                :style="{ left: (popupPosition.left+'px'), top: (popupPosition.top+'px'), right: (popupPosition.right+'px'), bottom: (popupPosition.bottom+'px'), maxHeight: ((popupPosition.maxHeight+'px')) }"
                @mouseup="mouseUpHandler"
                >

                <v-list v-if="!loading && filteredItemsLength==0" density="compact" :style="{ minWidth: ((popupPosition.minWidth+'px')) }">
                    <v-list-item>
                        <v-list-item-title v-text="props.noOptions"></v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-list v-if="loading && filteredItemsLength==0" density="compact" :style="{ minWidth: ((popupPosition.minWidth+'px')) }">
                    <v-list-item>
                        <DataLoading :type=2 :delay="1000"/>
                    </v-list-item>
                </v-list>

                <v-list v-if="!loading && filteredItemsLength>0" density="compact" :style="{ minWidth: ((popupPosition.minWidth+'px')) }">
                    <v-list-item 
                        ref="itemsRef"
                        v-show = "!item.noSelect" 
                        v-for="(item, i) in filteredItems"
                        :key="i"
                        :value="item"
                        active-color="primary"
                        :class="isSelected(item.id) ? 'v-list-item-selected' : ''"
                        @click.stop="toggleOption(item.id)"
                        >
                        <template v-slot:prepend>
                            <v-checkbox
                                :model-value="isSelected(item.id)"
                                hide-details
                                density="compact"
                                @click.stop="toggleOption(item.id)"
                            ></v-checkbox>
                        </template>

                        <v-list-item-title v-text="item.name" :style="{ marginLeft: '10px' }">
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
                
                <div class="actions">
                    <v-btn v-for="(item, i) in props.params.actions" :key="i" icon="mdi-pencil" color="primary" size="small" @click.stop.prevent="callActionHandler($event, i)"></v-btn>
                </div>
            </div>
        </Teleport>
    </div>
</template>



<script>
    import { ref, reactive, watch, computed, nextTick, onMounted, onUnmounted, onBeforeMount, onActivated, inject } from 'vue';

    

    export default {
        name: 'GridMultiSelectEditorNeo',
        //PROPS
        props: {
            noOptions: {
            type: String,
            default: 'No Matches'
            }
        },        
		setup(props, context){
            //CONSTANTS
            const value = ref([]);
            const formattedValue = ref('');
            const items=ref([]);
            const filter=ref('');
            const opened=ref(false);
            const popupPosition=reactive({
                left: 'auto',
                top: 'auto',
                right: 'auto',
                bottom: 'auto',
                maxHeight: 'auto',
                minWidth: 'auto'
            });
            const filteredItems = computed(()=>{
                if (filter.value==''){
                    return items.value;
                }else{
                    return items.value.filter(item => item.name && item.name.toUpperCase().indexOf(filter.value.toUpperCase())!=-1);
                }
            });
            const filteredItemsLength = computed(()=>{
                return filteredItems.value.length;
            });
            const newValueSelected = ref(false);
            const loading=ref(false);
            
            
            //REFERENCES
            const input=ref();
            const itemsRef=ref();
            const root=ref();
            const popup=ref();
            
            
            
            //INJECTIONS
            const axios = inject('axios');



            //VARIABLES

            
            
            
            //WATCHERS
            watch(opened, (newOpened) => {
                if (newOpened){
                    let position = input.value.getBoundingClientRect();
                    
                    if (position.top>window.innerHeight/2){
                        popupPosition.top='auto';
                        popupPosition.bottom=window.innerHeight-position.top;
                        popupPosition.maxHeight=position.top;
                    }else{
                        popupPosition.bottom='auto';
                        popupPosition.top=position.bottom;
                        popupPosition.maxHeight=window.innerHeight-position.bottom;
                    }
                    
                    if (position.left>window.innerWidth/2){
                        popupPosition.left='auto';
                        popupPosition.right=window.innerWidth-position.right-10;
                    }else{
                        popupPosition.left=position.left;
                        popupPosition.right='auto';
                    }
                    popupPosition.minWidth=position.width;
                }
            });
            watch(value, (newValue) => {
                updateFormattedValue();
            }, { deep: true });
            
            
            //EVENTS
            onBeforeMount(() => {
                // Initialize value from params
                if (props.params.value) {
                    if (Array.isArray(props.params.value)) {
                        value.value = [...props.params.value];
                    } else {
                        value.value = [props.params.value];
                    }
                } else {
                    value.value = [];
                }
                
                if (!props.params.colDef.cellEditorParams.loadFromUrl){
                    let tmpItems=[];
                    setTimeout(function(){
                        tmpItems=(typeof props.params.colDef.cellEditorParams === 'function') ? props.params.colDef.cellEditorParams(props.params).valueList : props.params.colDef.cellEditorParams.valueList;
                        if (tmpItems && Array.isArray(tmpItems)) {
                            items.value=[...(tmpItems.sort((a,b) => b.id==null ? 1 : ( a.id==null ? -1 : ((a.name>b.name) ? 1 : ((b.name > a.name) ? -1 : 0))) )) ];
                        }
                        updateFormattedValue();
                    },1);
                }
            });
            onMounted(() => {
                document.addEventListener('click', blurHandler);
            })
            onUnmounted(() => {
                document.removeEventListener('click', blurHandler);
            });
            
            
            //METHODS
            const getValue = () => {
                return value.value;
            }
            const isPopup = () => {
                return false;
            }
            const isSelected = (itemId) => {
                return value.value.includes(itemId);
            }
            const toggleOption = (sel) => {
                const index = value.value.indexOf(sel);
                if (index > -1) {
                    value.value.splice(index, 1);
                } else {
                    value.value.push(sel);
                }
            }
            
            const updateFormattedValue = () => {
                if (value.value.length === 0) {
                    formattedValue.value = '';
                } else {
                    // Get the names of selected items
                    const selectedNames = value.value.map(id => {
                        const item = items.value.find(i => i.id === id);
                        return item ? item.name : id;
                    });
                    formattedValue.value = selectedNames.join(', ');
                }
            }
            
            const keyPressHandler = (event) => {
                switch (event.keyCode){
                    case 13:
                        opened.value=!opened.value;
                        break;                
                    default:
                        if (event.key.length === 1) {
                            if (newValueSelected.value){
                                newValueSelected.value=false;
                                filter.value='';
                            }
                            filter.value+=event.key;
                        }
                }
            }
            
            const mouseUpHandler = (event) => {
                input.value.focus();
            }
            
            const callActionHandler = (event, index) => {
                if (Array.isArray(props.params.actions) && props.params.actions[index]){
                    props.params.actions[index].actionCall();
                }
            }
            
            const blurHandler = (event) => {
                if (root.value!==undefined && root.value.contains(event.target)===false) {
                    opened.value=false;
                }
            }
            
            const focusIn = () => {
                input.value.focus();
                opened.value=true;
            }
            const focusOut = () => {
                opened.value=false;
            }

            return{
                props,
                root,
                popup,
                input,
                itemsRef,
                value,
                loading,
                filter,
                opened,
                filteredItems,
                filteredItemsLength,
                newValueSelected,
                getValue,
                isPopup,
                isSelected,
                toggleOption,
                keyPressHandler,
                mouseUpHandler,
                callActionHandler,
                blurHandler,
                focusIn,
                focusOut,
                popupPosition,
                formattedValue,
                updateFormattedValue
            }

        }
    }
</script>

<style>
    .neo-inputer{
        width: 100%;
        height: 100%;
    }
    .neo-inputer input{
        width: 100%;
        height: 100%;
        padding-left: 5px;
    }
    .neo-selector{
        position: absolute !important;
        z-index: 9999 !important;
        display: flex;
        flex-direction: row;
        background-color: transparent;
    }
    .neo-selector .actions{
        background-color: transparent;
        padding: 5px;
    }
    .neo-selector .v-list{
        padding: 0;
        max-height: 100%; 
        flex:1; 
        overflow:auto;
        border:1px solid lightgray;
        background-color: white !important;
        box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
    }
    .neo-selector .v-list .v-list-item{
        padding: 12px 5px 12px 5px;
    }
    .neo-selector .v-list .v-list-item .v-input__control .v-field__field{
        padding: 0 !important;
        min-height: auto !important;
    }
    .neo-selector .v-list .v-list-item input{
        font-size: 14px;
        text-align: right;
    }
    .neo-selector .v-field__field{
        padding: 0 !important;
    }
    .neo-selector .v-list-item-selected{
        background-color: #f5f5f5;
    }
</style>

